import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/governance/new/loading';

export const Route = createFileRoute('/_private/governance/new')({
  pendingComponent: Loading,
});
